/*
 * Copyright (c) 2018. Viscomp LLC. All rights are reserved!
 */

'use strict';

function Pagination(e, data) {
  this.code = '';
  data = data || {};
  this.size = data.size || 300;
  this.page = data.page || 1;
  this.step = data.step || 3;
  this.onChange = data.onChange || null;
  this.wrapperClass = data.wrapperClass;
  this.Create(e);
  this.Start();
}
Pagination.prototype.Add = function (s, f) {
  for (let i = s; i < f; i++) {
    this.code += '<button type="button">' + i + '</button>';
  }
};
Pagination.prototype.Last = function () {
  this.code += '<i>...</i><button type="button">' + this.size + '</button>';
};
Pagination.prototype.First = function () {
  this.code += '<button type="button">1</button><i>...</i>';
};
Pagination.prototype.Click = function (el, self) {
  self.page = +el.innerHTML;
  self.onChange && self.onChange(self.page);
  self.Start();
};
Pagination.prototype.Prev = function () {
  this.page--;
  if (this.page < 1) {
    this.page = 1;
  }
  this.onChange && this.onChange(this.page);
  this.Start();
};
Pagination.prototype.Next = function () {
  this.page++;
  if (this.page > this.size) {
    this.page = this.size;
  }
  this.onChange && this.onChange(this.page);
  this.Start();
};
Pagination.prototype.Bind = function () {
  let buttons = this.e.getElementsByTagName('button');
  let self = this;
  for (let i = 0; i < buttons.length; i++) {
    if (+buttons[i].innerHTML === this.page) buttons[i].className = 'current';
    buttons[i].addEventListener('click', function () {
      self.Click(this, self);
    }, false);
  }
};
Pagination.prototype.Finish = function () {
  this.e.innerHTML = this.code;
  this.code = '';
  this.Bind();
};
Pagination.prototype.Start = function () {
  if (this.size < this.step * 2 + 6) {
    this.Add(1, this.size + 1);
  } else if (this.page < this.step * 2 + 1) {
    this.Add(1, this.step * 2 + 4);
    this.Last();
  } else if (this.page > this.size - this.step * 2) {
    this.First();
    this.Add(this.size - this.step * 2 - 2, this.size + 1);
  } else {
    this.First();
    this.Add(this.page - this.step, this.page + this.step + 1);
    this.Last();
  }
  this.Finish();
};
Pagination.prototype.Buttons = function (e) {
  e.querySelector('[data-nav-btn-prev]').addEventListener('click', this.Prev.bind(this), false);
  e.querySelector('[data-nav-btn-next]').addEventListener('click', this.Next.bind(this), false);
};

// create skeleton
Pagination.prototype.Create = function (e) {
  let html = ['<li><button data-nav-btn="" data-nav-btn-prev="" type="button" class="prev-btn">◄</button></li>',
  // previous button
  '<li class="gallery-nav"></li>',
  // pagination container
  '<li><button data-nav-btn="" data-nav-btn-next="" type="button" class="next-btn">►</button></li>' // next button
  ];
  e.innerHTML = html.join('');
  this.e = e.querySelector('.gallery-nav');
  this.Buttons(e);
  if (this.wrapperClass !== void 0) {
    this.e.classList.add(this.wrapperClass);
  }
};
export { Pagination };